// import React from "react";
import { GetStaticProps } from "next/types"
import nextI18nextConfig from "next-i18next.config"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import { Page } from "types/page"
import { OlympiadCampaignPartners, OlympiadPartnersHero } from "@cs/screens/olympiad"
import olympiadLayout from "../../layouts/Olympiad.layout"
import OlympiadPrivateQualifier from "@cs/screens/olympiad/private-qualifier/OlympiadPrivateQualifier"

const OlympiadPartnersPage: Page = () => (
  <main>
    <OlympiadPartnersHero />
    <OlympiadCampaignPartners />
    <OlympiadPrivateQualifier />
  </main>
)

OlympiadPartnersPage.getLayout = olympiadLayout

export default OlympiadPartnersPage

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: await serverSideTranslations(
    locale ?? "en",
    ["common", "footer", "nav", "olympiad", "_links", "landing-page"],
    nextI18nextConfig,
  ),
})
